
































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Base } from '@/components/common/base';
import { jobStatusService } from '@/shared';
import { VHeaders } from '@/models/pagedlistmodel';

@Component({
  components: {
    AppGrid: () => import('@/components/common/app.grid.vue'),
  }
})

export default class JobStatusPage extends Base {

  public loading = false;

  public isSearchLoading = false;

  public items: any[] = [];

  public allItems: any[] = [];

  public searchText = '';

  public storeId: number;

  public flags = {
    invalidUrl: false,
    showReportDatePicker: false,
  };


  public headers: VHeaders[] = [
    
    {
      text: 'Job Name',
      value: 'jobName',
      sortable: false,
      color: (item) => !item.isErpActive ? 'erp-inactive-cell' : '',
    },
    {
      text: 'Status',
      value: 'isActive',
      sortable: false,
      color: (item) => !item.isErpActive ? 'erp-inactive-cell' : '',
    },
    {
      text: 'DT Endpoints Access Denied',
      value: 'missingEndpoints',
      sortable: false,
      color: (item) => !item.isErpActive ? 'erp-inactive-cell' : '',
    }
  ];

  public created(): void {
    this.storeId = this.userSession?.storeId;
}

  public mounted(): void {
    this.$root.$emit('sidebar.layout.vue', 'jobstatus');

    this.searchJobStatusList();
  }

  public async searchJobStatusList(): Promise<void> {
    if (!this.storeId) {
       this.showAlert(false, 'No Store Selected');
       this.items = [];
       this.allItems = [];
       return;
     }

    try {
      this.loading = true;

      const response = await jobStatusService.getJobStatusListAsync(this.storeId);

      this.allItems = (response?.jobStatuses || [])
      .sort((a, b) => a.jobName.localeCompare(b.jobName))
      .map(x => ({
        ...x,
        missingEndpoints: x.missingEndpoints?.join(', ') || '',
        isActive: x.isActive ? 'Active' : 'Inactive',
      }));

      this.items = [...this.allItems];
    }
    finally {
      this.loading = false;
    }
  }

  public filterData(): void {

  const search = this.searchText?.toLowerCase().trim();

  if (!search) {
    this.items = [...this.allItems];
    return;
  }

  this.items = this.allItems.filter(item =>
    Object.values(item).some(value =>
      value !== null &&
       value !== undefined &&
      value.toString().toLowerCase().includes(search)
    )
  );
}

}
